import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details__row py-4"},[_c(VRow,[_c(VDataTable,{staticClass:"w-100 my-n4",attrs:{"headers":_vm.detail.fields,"items":_vm.invoiceItems,"item-key":"uniqueKey","hide-default-footer":"","items-per-page":500,"width":"100%"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }